import { Table } from "react-bootstrap";
import "./ReportTable.scss";

function ReportTable({ reportData }) {
  return (
    <Table className="report-table">
      <thead>
        <tr>
          <th>Module ID</th>
          <th>Element Type</th>
          <th>Attribute</th>
          <th>Element ID</th>
          <th>Content</th>
         {/*  <th>count</th>  */}
        </tr>
      </thead>

      <tbody>
        {reportData
          .filter((data) => data.count < 1)
          ?.map((item, index) => (
            <tr key={index}>
              <td>{item.moduleId}</td>
              <td>{item.elementType}</td>
              <td>{item.attribute}</td>
              <td>{item.elementId}</td>
              <td>
                {" "}
                {item.attribute === "Image" && item.content ? (
                  <img
                    src={item.content}
                    alt="Component"
                    style={{ maxWidth: "100px", maxHeight: "100px" }}
                  />
                ) : (
                  item.content  
                )}
              </td>
              {/* <td>{ item.count}</td> */}
            </tr>
          ))}
      </tbody>
    </Table>
  );
}

export default ReportTable;
